import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APGenericSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APGenericSlotServant } from '../../../global/servants/ap_generic_slot_servant';

export class PlannerCourseDeleteArea {
  private dummyPlaceholderList: any[] = [];
  constructor(
    private removeCourseFromTermCommand: ICommand,
    private removeCourseGroupFromTermCommand: ICommand,
    private log: any,
    private phxAxTitleAnnouncerDelegate: any,
    private appConfigModel: any,
    private loadMmAcademicPlanCommand: ICommand,
    private removeMmCourseFromTermCommand: ICommand,
    private removeMmCourseGroupFromTermCommand: ICommand
  ) {}

  async dropCallback(event: ng.IAngularEvent, index: number, genericSlot: any) {
    const isMultiPlanEnabled = this.appConfigModel.isFeatureEnabled('cat-multitemplate_planner');
    if (isMultiPlanEnabled) {
      const slotType = _4.get(genericSlot, 'slotType', 'COURSE');
      const plannedCourseId = _4.get(genericSlot, 'plannedCourseId', 0);
      if (slotType === 'COURSE') {
        this.removeMmCourseFromTermCommand(plannedCourseId).then((studentId: number) => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      } else {
        this.removeMmCourseGroupFromTermCommand(plannedCourseId).then((studentId: number) => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      }
    } else {
      try {
        if (!APGenericSlotServant.isNCRSlot(genericSlot) && !_4.isEmpty(genericSlot.plannedCourse)) {
          await this.removeCourseFromTermCommand(genericSlot.programSlot, genericSlot.plannedCourse);
        } else if (!APGenericSlotServant.isCourseSlot(genericSlot) && !_4.isEmpty(genericSlot.plannedCourseGroup)) {
          await this.removeCourseGroupFromTermCommand(genericSlot.programSlot, genericSlot.plannedCourseGroup.id);
        }
        this.phxAxTitleAnnouncerDelegate.announceChange(`${genericSlot.title} was removed`);
      } catch (err) {
        this.log.error('Unable to delete your course.');
        console.error(err);
      }
    }
  }
}

angular.module('capability-ng-academic-planner').component('plannerCourseDeleteArea', {
  templateUrl:
    'capability-ng-academic-planner/src/plan/components/planner_course_delete_area/planner_course_delete_area.html',
  controller: PlannerCourseDeleteArea,
  transclude: true
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_course_delete_area/planner_course_delete_area.ts